'use client';

import { vertexShader, fragmentShader } from './shaders/FluidGradient';
import ShaderCanvas from './ShaderCanvas';

export default function HeroBackground() {
  return <ShaderCanvas vertexShader={vertexShader} fragmentShader={fragmentShader} />;
}
